<app-student-form
  [response]="response"
  (onSubmitCallback)="onSubmit($event[0])"
  [examReportId]="examReportId"
  [studentId]="studentId"
></app-student-form>
